import { render, staticRenderFns } from "./ConfirmStart.vue?vue&type=template&id=6d0daa00&scoped=true&"
import script from "./ConfirmStart.vue?vue&type=script&lang=js&"
export * from "./ConfirmStart.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmStart.vue?vue&type=style&index=0&id=6d0daa00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0daa00",
  null
  
)

export default component.exports